<template>
  <div id="knowledge-base-page">

    <vs-button v-if="$acl.check('SuperAdmin')" color="primary" size="large" class="mt-3 mb-8" type="filled"
      to="/knowledgebase/new"> Create New Block
    </vs-button>
    <!-- JUMBOTRON -->
    <div class="knowledge-base-jumbotron">
      <div class="knowledge-base-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
        <h1 class="mb-1 text-white">SDK and Web API Documentation</h1>
        <p class="text-white">You can click on which platform you use or type your keyword.</p>
        <vs-input icon-no-border placeholder="Search Topic or Keyword" v-model="knowledgeBaseSearchQuery"
          icon-pack="feather" icon="icon-search" size="large" class="w-full mt-6" />
      </div>
    </div>

    <!-- KNOWLEDGE BASE CARDS  -->
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/3 sm:w-1/2 mb-base" v-for="item in filteredKB" :key="item.id">
        <vx-card class="text-center cursor-pointer">
          <img @click="$router.push(`/knowledge-base/knowledgebase-detail/${item.id}`).catch(() => {})"
            :src="`${authConfig.uploadPath}${item.imagePath}`" alt="graphic" width="180" class="mx-auto mb-4">
          <h4 @click="$router.push(`/knowledge-base/knowledgebase-detail/${item.id}`).catch(() => {})" class="mb-2">
            {{ item.title.toUpperCase() }}</h4>
          <small>{{ item.description }}</small>
          <div class="edit-overlay">
            <vs-button v-if="$acl.check('SuperAdmin')" color="primary" class="mt-3 mb-8 mr-2" type="filled"
              @click="$router.push(`/post-list/${item.id}`).catch(() => {})"> Edit </vs-button>
            <vs-button v-if="$acl.check('SuperAdmin')" color="danger" class="mt-3 mb-8" type="filled"
              @click="confirmDelete(item.title , item.id)"> Delete </vs-button>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  import authConfig from '@/../auth_config.json'
  export default {
    data() {
      return {
        authConfig: authConfig,
        knowledgeBaseSearchQuery: '',
        selectedId:'',
        kb: [{
            id: 1,
            title: 'OCR Android SDK',
            description: 'Reading and verifying identity cards and passports.',
            graphic: require('@/assets/images/pages/graphic-6.png'),
            url: '/knowledge-base/ocr-android'
          },
          {
            id: 2,
            title: 'OCR IOS SDK',
            description: 'Reading and verifying identity cards and passports.',
            graphic: require('@/assets/images/pages/graphic-6.png'),
            url: '/knowledge-base/ocr-ios'
          },
          {
            id: 3,
            title: 'Face Matching Web Api',
            description: 'This api gives the similarity ratio between two(2) images.',
            graphic: require('@/assets/images/pages/graphic-3.png'),
            url: '/knowledge-base/face-matching'
          },
          {
            id: 4,
            title: 'Liveness web API',
            description: 'This api gives the similarity ratio between two(2) images.',
            graphic: require('@/assets/images/pages/graphic-4.png'),
            url: '/knowledge-base/liveness'
          },


        ]
      }
    },
    created() {
      this.getPosts();
    },
    computed: {
      filteredKB() {
        return this.kb.filter((item) => item.title.toLowerCase().includes(this.knowledgeBaseSearchQuery
        .toLowerCase()) || item.description.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase()))
      }
    },
    methods: {
      confirmDelete(title, id) {
        this.selectedId = id
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm Delete',
          text: `You are about to delete "${title}"`,
          accept: this.deletePost,
          acceptText: 'Delete'
        })
      },
      deletePost() {

        this.$vs.loading()

        this.$store.dispatch('post/deletePost', this.selectedId)
          .then(response => {

            this.getPosts()
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Successfull',
              text: response.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })

          })
          .catch(error => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })



      },
      getPosts() {
        this.$store.dispatch('post/getPosts')
          .then(response => {

            this.kb = response.data.filter(post => post.dataType == 2)
          })
          .catch(error => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
      }
    },
    components: {}
  }
</script>

<style lang="scss">
  .knowledge-base-jumbotron-content {
    background-image: url('../assets/images/pages/knowledge-base-cover.jpg');
    background-size: cover;
  }
</style>